

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.D571lp1H.js","_app/immutable/chunks/DsnmJJEf.js","_app/immutable/chunks/CWRehctP.js","_app/immutable/chunks/D3MuNBmD.js","_app/immutable/chunks/B5U7fqmF.js","_app/immutable/chunks/DgPgFJyF.js","_app/immutable/chunks/DERV-J3L.js","_app/immutable/chunks/CXZTR9LB.js","_app/immutable/chunks/BzfD0-ZS.js","_app/immutable/chunks/BuPXQUT0.js"];
export const stylesheets = [];
export const fonts = [];
